/**
 *
 * IBM Confidential
 *
 * (C) Copyright IBM Corp. 2021, 2024
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U. S. Copyright Office
 *
 * US Government Users Restricted Rights - Use, duplication or
 * disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 *
 **/

import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  discoDescription: {
    id: 'searchInstance.discoDescription',
    defaultMessage: `IBM Watson Discovery uses your existing data and content to answer your users' questions.<link>Learn more</link>`
  },
  chooseDiscoLabel: {
    id: 'searchInstance.chooseDiscoLabel',
    defaultMessage: 'Choose a Discovery instance to connect to'
  },
  discoveryProjects: {
    id: 'searchInstance.discoveryProjects',
    defaultMessage: 'Discovery Projects'
  },
  chooseDiscoTooltip: {
    id: 'searchInstance.chooseDiscoTooltip',
    defaultMessage:
      'A Watson Discovery service stores data which you have manually uploaded or linked to an external source such as Salesforce or SharePoint.'
  },
  missingCreds: {
    id: 'searchInstance.missingCreds',
    defaultMessage:
      'Some of your Discovery instances do not have credentials set.'
  },
  missingCollection: {
    id: 'searchInstance.missingCollection',
    defaultMessage:
      'Your project is empty, you are required to add a collection to it before you can proceed.'
  },
  closeErrorDescription: {
    id: 'searchInstance.closeErrorDescription',
    defaultMessage: 'close error'
  },
  createAnother: {
    id: 'searchInstance.createAnother',
    defaultMessage:
      'To create a new Discovery instance, visit the <link>discovery catalog</link>.'
  },
  chooseProjectLabel: {
    id: 'searchInstance.chooseProjectLabel',
    defaultMessage: 'Choose which project you want to use'
  },
  chooseProjectTooltip: {
    id: 'searchInstance.chooseProjectTooltip',
    defaultMessage:
      'A collection in Watson Discovery groups files which can be used by your assistant.'
  },
  createNewProject: {
    id: 'searchInstance.createNewProject',
    defaultMessage: 'Create a new project'
  },
  projectName: {
    id: 'searchInstance.projectName',
    defaultMessage: 'Project name'
  },
  collectionName: {
    id: 'searchInstance.collectionName',
    defaultMessage: 'Collection Name'
  },
  openInDiscovery: {
    id: 'searchInstance.openInDiscovery',
    defaultMessage: 'Open Watson Discovery'
  },
  unavailable: {
    id: 'searchInstance.unavailable',
    defaultMessage: 'Unavailable'
  },
  instanceUnavailable: {
    id: 'searchInstance.instanceUnavailable',
    defaultMessage: 'This instance is not available. Please try again later.'
  },
  loadingInstances: {
    id: 'searchInstance.loadingInstances',
    defaultMessage: 'Loading instances...'
  },
  createNewProjectBringData: {
    id: 'searchInstance.createNewProjectBringData',
    defaultMessage: 'Create a new project and bring in data to get started.'
  },
  noProjectsYet: {
    id: 'searchInstance.noProjectsYet',
    defaultMessage: 'There are no projects yet.'
  }
});
